import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import Link from 'valuelink';
import {
  Button,
  Col,
  Icon,
  List,
  Modal,
  Row,
  Select,
  Spin,
  Switch,
  Card,
  message,
  Typography,
  Form,
  Input as AntInput,
} from 'antd';
import { Input } from 'valuelink/lib/tags';
import { SemiboldText, ButtonText } from '../../components/common/Text';
import {
  uploadProfilePicture,
  submitNetworkCenterFulfilment,
  getCentersWithBeneficiary,
  fetchCenters,
  fetchCortisBillingEntitities,
  fetchBankDetailsFromIfscCode,
  verifyUpi,
  verifyBankAccount,
  fetchCenterFulfilments,
  modifyAndFetchCenterFulfilments,
  removeNetworkCenterFulfilmentDetails,
} from '../../services';
import { fetchCenterBasicProfile } from '../../services';
import { debounce, showError } from '../../utils';
import { ThreeDots } from 'react-loader-spinner'
import NetworkCenterMoUAddScreen from './NetworkCenterMoUAddScreen';
import ApprovalRequests from '../approval-requests/ApprovalRequests';

const { Paragraph, Title } = Typography;

const { Option } = Select;

const TitleText = styled(SemiboldText)`
  font-size: 1.5rem;
  text-align: center;
  color: #666569;
`;

const BodyContainer = styled.div`
  display: flex;
  flex: 1 0;
  flex-direction: column;
  align-items: stretch;
  margin-bottom: 20px;
  /* over */
`;
const popupStyle = {
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: 'white',
  padding: '20px',
  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
  zIndex: 1000,
};

const buttonStyle = {
  marginTop: '10px',
  padding: '5px 10px',
};

const StyledInputBox = styled(Input)`
  font-size: 16px !important;
  background-color: #f8f8f8;
  align-self: stretch;
  border-radius: 6px;
  flex: 1;
  flex-shrink: 0;
  min-width: 180px;
  width: 100%;
  height: 44px;
  padding: 6px 12px;
  align-items: center;
  margin-bottom: 14px;
`;

const LabelText = styled(SemiboldText)`
  font-size: 12px;
  text-align: center;
  margin-bottom: 0.25rem;
  margin-top: 0.625rem;
  color: #7c7c7c;
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
`;

const ParagraphText = styled(SemiboldText)`
  font-size: 10px;
  text-align: center;
  margin-top: 0.625rem;
  color: red;
  display: flex;
  flex-shrink: 0;
  flex-direction: row;
  float: right;
`;

const VerifyBtnY = styled.button`
width: 90px;
height: 35px;
display: flex;
padding: 8px 12px;
justify-content: center;
align-items: center;
gap: 4px;
border-radius: 8px;
border-color: transparent;
background: #4096ff;
color: #FFF;
cursor: pointer;
`;

const VerifyBtnN = styled.div`
width: 90px;
height: 35px;
display: flex;
padding: 8px 12px;
justify-content: center;
align-items: center;
gap: 4px;
border-radius: 8px;
border-color: transparent;
background: #f0f0f0;
color: #bfbfbf;
cursor: not-allowed;
`;

const EduRowComponent = styled.div`
  display: flex;
  flex-direction: column;
`;

const ConfirmUpdateCentersFulfilments = ({ centers }) => (
  <>
    <Typography.Title level={4}>
      The below centers have the same fulfilment details. Please confirm if you
      want to update all or only this center
    </Typography.Title>
    <List
      dataSource={centers}
      renderItem={(item) => (
        <List.Item>
          <Button
            type="link"
            href={`/center-profile/${item.centerId}`}
            target="_blank"
          >
            {item.name}
          </Button>
        </List.Item>
      )}
    />
  </>
);

class NetworkCenterFulfilment extends Component {
  constructor(props) {
    super(props);
    //
    this.state = {
      loading: false,
      fulfilmentLoading: true,
      showAddFulfilmentForm: false,
      updateSameDetail: false,
      showAddEditForm: false,
      saving: false,
      saved: false,
      amhi: {
        status: 0,
        errorMessage: '',
      },
      acko: {
        status: 0,
        errorMessage: '',
      },
      ackocopay: {
        status: 0,
        errorMessage: '',
      },
      requiredValues: {

      },
      payeeName: '',
      accountNumber: '',
      accountType: '',
      ifscCode: '',
      paytmNumber: '',
      upiAddress: '',
      visitSpoc: '',
      beneficiaryId: null,
      preferredPaymentMode: 'Bank Account',
      paymentCycle: 'before consultation',
      remarks: '',
      invoiceMandatory: 0,
      fetchingCenters: false,
      fetchedCenters: [],
      masterHospitalId: null,
      masterHospitalName: null,
      tdsPercentage: '',
      showError: false,
      maternityDiscount: 0,
      maternityCenter: false,
      billingEntities: [],
      billingEntityId: '',
      zohoVendorId: '',
      pan: '',
      zohoCompanyName: '',
      zohoVendorName: '',
      nameAsPerPan: '',
      selectingBillingEntity: false,
      bankName: '',
      branchName: '',
      upicheck: false,
      bankcheck: false,
      upiVerified: false,
      bankVerified: false,
      verifyLoading: false,
      filterVistSpocs: this.props.visitSpocs,
      lastupiAddress: '*',
      lastaccnumber: '*',
      lastifsc: '*',
      fetchedIfsc: '',
      fetchedaccountNumber: '',
      fetchedupi: '',
      validBankresponse: false,
      validUpiresponse: false,
      centerFulfilments: [],
      fetchedCenterFulfilments: [],
      preViusFulfilmentDetail: {
        payeeName: '',
        accountNumber: '',
        accountType: '',
        branchName:'',
        bankName:'',
        ifscCode: '',
        upiAddress: '',
        visitSpoc: '',
        preferredPaymentMode: '',
        paymentCycle: '',
        remarks: '',
        invoiceMandatory: null,
        masterHospitalId: null,
        tdsPercentage: '',
      },
      isAnyFieldChanged: false,
      requestSendStatus:false,
      requestSendStatusMessage:'',
    };
    //let isAnyFieldChanged=false;

    this.debouncedFetchHealthCenters = debounce(this.onSearchCenter, 600);
    this.centerId = props.centerId;
    this.getMouTab = props.getMouTab;
    this.isCenterEnabled = props.isCenterEnabled;
  }

  componentDidMount = () => {
    if (this.centerId) {
      this.fetchProfile();
      this.checkIfVerificationprofileExists();
      this.getCenterFulfilments(this.centerId);
    }
  };

  // componentDidMount() {
  //   // After the component has mounted, set the flag to false

  // }

  componentDidUpdate(prevProps, prevState) {
    const { accountNumber, ifscCode, upiAddress, lastupiAddress, lastaccnumber, lastifsc, fetchedaccountNumber, fetchedIfsc, fetchedupi } = this.state;
    if (accountNumber !== prevState.accountNumber || ifscCode !== prevState.ifscCode) {
      // check for bankAccount
      let patternBank = /^[a-zA-Z0-9]+$/;
      const accountPatternVerified = patternBank.test(accountNumber);
      let patternIfsc = /^[A-Z]{4}0[A-Z0-9]{6}$/;
      const ifscPatternVerified = patternIfsc.test(ifscCode);
      console.log(accountPatternVerified, ifscPatternVerified);
      accountNumber && accountNumber.length > 8 && ifscCode && accountPatternVerified && ifscPatternVerified ? this.setState({ bankcheck: true, bankVerified: false }) : this.setState({ bankcheck: false, bankVerified: false });
    }
    if (upiAddress !== prevState.upiAddress) {
      let patternUpi = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+$/;
      const upiPatternVerified = patternUpi.test(upiAddress);
      upiAddress && upiPatternVerified ? this.setState({ upicheck: true, upiVerified: false }) : this.setState({ upicheck: false, upiVerified: false });
    }
    // if (prevState.payeeName != this.state.payeeName || prevState.accountNumber != this.state.accountNumber 
    //   || prevState.ifscCode != this.state.ifscCode || prevState.accountType != this.state.accountType 
    //   || prevState.bankName != this.state.bankName || prevState.upiAddress != this.state.upiAddress 
    //   || prevState.branchName != this.state.branchName || prevState.payeeName != this.state.payeeName 
    //   || prevState.visitSpoc != this.state.visitSpoc || prevState.remarks != this.state.remarks 
    //   || prevState.preferredPaymentMode != this.state.preferredPaymentMode || Boolean(prevState.invoiceMandatory) != Boolean(this.state.invoiceMandatory)
    //   || prevState.paymentCycle != this.state.paymentCycle 
    //   || prevState.masterHospitalId != this.state.masterHospitalId) {

    //   this.checkIfFulfilmentDetailsChangedInForm()
    // }


  }

  fetchProfile = () => {
    this.setState({ loading: true });
    fetchCenterBasicProfile(this.centerId)
      .then((res) => {
        const basicProfile = res;
        const { fulfilment, centerDetails } = basicProfile;
        if (fulfilment) {
          this.setState({
            assistantName: fulfilment.assistantName || '',
            assistantNumber: fulfilment.assistantNumber || '',
            payeeName: fulfilment.payeeName || '',
            accountNumber: fulfilment.accountNumber || '',
            accountType: fulfilment.accountType || '',
            ifscCode: fulfilment.ifscCode || '',
            bankName: fulfilment.bankName || '',
            branchName: fulfilment.branch || '',
            paytmNumber: fulfilment.upiPhone || '',
            upiAddress: fulfilment.upiAddress || '',
            visitSpoc: fulfilment.visitSpoc || '',
            preferredPaymentMode: fulfilment.preferredPayment || '',
            paymentCycle: fulfilment.paymentCycle || '',
            remarks: fulfilment.remarks || '',
            invoiceMandatory: fulfilment.invoiceMandatory || 0,
            beneficiaryId: fulfilment.payoutBeneficiaryId,
            tdsPercentage: fulfilment.tdsPercentage,
            maternityDiscount: fulfilment.maternityDiscount,
            billingEntityId: fulfilment.cortisBillingId,
            zohoVendorId: fulfilment.zohoVendorId,
            pan: fulfilment.pan,
            zohoCompanyName: fulfilment.zohoCompanyName,
            zohoVendorName: fulfilment.zohoVendorName,
            nameAsPerPan: fulfilment.nameAsPerPan,
          });
          this.setState(prevState => ({
            preViusFulfilmentDetail: {
              ...prevState.preViusFulfilmentDetail,
              payeeName: fulfilment.payeeName || '',
              accountNumber: fulfilment.accountNumber || '',
              ifscCode: fulfilment.ifscCode || '',
              bankName: fulfilment.bankName || '',
              accountType: fulfilment.accountType || '',
              branchName: fulfilment.branch || '',
              upiAddress: fulfilment.upiAddress || '',
              visitSpoc: fulfilment.visitSpoc || '',
              preferredPaymentMode: fulfilment.preferredPayment || '',
              remarks: fulfilment.remarks || '',
              invoiceMandatory: fulfilment.invoiceMandatory || 0,
              tdsPercentage: fulfilment.tdsPercentage || '',
              paymentCycle: fulfilment.paymentCycle || '',
              masterHospitalId: centerDetails.masterId || null,
              preViusFulfilmentDetailUpdated: true
            }
          }));
        }

        this.setState({
          maternityCenter: centerDetails.maternityCenter ? true : false,
          masterHospitalId: centerDetails.masterId,
          masterHospitalName: centerDetails.masterHospitalName,
        });
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  customStyles = {
    option: (provided) => ({
      ...provided,
      fontSize: 16,
      color: '#514f54',
    }),
    placeholder: (provided) => ({
      ...provided,
      fontFamily: 'ProximaNova-Regular, Lato, sans-serif',
      fontSize: 16,
      color: '#514f54',
    }),
    singleValue: (provided) => ({
      ...provided,
      fontFamily: 'ProximaNova-Regular, Lato, sans-serif',
      fontSize: 16,
      color: '#514f54',
    }),
    valueContainer: (provided) => ({
      ...provided,
      fontFamily: 'ProximaNova-Regular, Lato, sans-serif',
      fontSize: 16,
      color: '#514f54',
    }),
    input: (provided) => ({
      ...provided,
      fontFamily: 'ProximaNova-Regular, Lato, sans-serif',
      fontSize: 16,
      color: '#514f54',
    }),
  };



  handleBillingEntityChange = (value) => {
    console.log('Billing Entity:', value);
    this.setState({
      selectingBillingEntity: true,
      billingEntityId: value,
    });
  };

  handleSearchNew = (value) => {
    console.log("value", value);
    if (!value) {
      return;
    }
    fetchCortisBillingEntitities(value)
      .then((data) => {
        console.log("result", data.result);
        this.setState({
          billingEntities: data.result
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };


  handleRequestRaisedStatus = () => {
    this.setState({ requestSendStatus: false })
  }

  handleAttachment = () => {
    const { authToken } = this.props;
    const file = document.querySelector('#imageAttachment').files[0];
    if (file) {
      this.setState({
        uploading: true,
      });
      document.querySelector('#imageAttachment').value = null;
      const onUploadProgress = (progressEvent) => {
        if (progressEvent.lengthComputable) {
          const { loaded, total } = progressEvent;
          this.setState({
            uploadProgress: (loaded / total) * 100,
          });
        } else {
          this.setState({
            uploadProgress: 100,
          });
        }
      };
      uploadProfilePicture(file, this.doctorId, onUploadProgress, authToken)
        .then(() => {
          this.setState({
            uploading: false,
            uploadProgress: 0,
          });
          this.fetchProfile();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  valueOrUndefined = (value) => {
    return value.trim() === '' ? undefined : value;
  };

  closedPopupInthreeSecond = () => {
    setTimeout(() => {
      this.closeSavingModal();
    }, 3000)
  }

  submit = () => {
    const {
      payeeName,
      accountNumber,
      accountType,
      ifscCode,
      paytmNumber,
      upiAddress,
      visitSpoc,
      preferredPaymentMode,
      paymentCycle,
      remarks,
      invoiceMandatory,
      beneficiaryId,
      savingTo,
      masterHospitalId,
      tdsPercentage,
      maternityDiscount,
      billingEntityId,
      selectingBillingEntity,
      bankName,
      branchName,
      upiVerified,
      bankVerified,
      upicheck
    } = this.state;

    if (visitSpoc === '' || payeeName === '') {
      this.setState({ saving: false });
      return message.error(
        'Kindly fill mandatory fields Visit Spoc and Payee Name',
        3
      );
    }
    // if (masterHospitalId == this.centerId) {
    //   return message.error('Center and Master hospital cannot be same.', 3);
    // }
    if (this.state.updateSameDetail==false)
    {
      const isAnyFieldChanged = this.checkIfFulfilmentDetailsChangedInForm()
      if (isAnyFieldChanged == false) {
        this.setState({ requestSendStatus: true, requestSendStatusMessage: "Please changed at least one filed" })
        return message.error("Please changed at least one filed");
      }
    }
    if (this.state.updateSameDetail == true) {
      const isAnyFieldChanged = this.checkIfFulfilmentDetailsChangedInForm()
      if (isAnyFieldChanged == true) {
        this.setState({ requestSendStatus: true, requestSendStatusMessage: "You have changed one or more fields. Please enter the same details" })
        return message.error("You have changed one or more fields. Please enter the same details");
      }
    }

    if (tdsPercentage && isNaN(tdsPercentage)) {
      return message.error('Wrong TDS Percentage', 3);
    }
    if (maternityDiscount && isNaN(maternityDiscount)) {
      return message.error('Wrong Maternity Discount', 3);
    }
    if (!upicheck && preferredPaymentMode === 'UPI') {
      this.setState({ saving: false });
      return message.error('Please verify the UPI address');
    }
    if (!bankVerified && preferredPaymentMode === 'Bank Account') {
      console.log(bankVerified, accountNumber, ifscCode);
      this.setState({ saving: false });
      return message.error('Please verify the bank details');
    }

    setTimeout(() => {
      const amhiSavingTo = {
        status: 1,
      };
      this.setState({ amhi: amhiSavingTo });
    }, 2000);
    setTimeout(() => {
      const amhiSavingTo = {
        status: -1,
        errorMessage: 'Something went wrong',
      };
      this.setState({ acko: amhiSavingTo });
    }, 3000);
    setTimeout(() => {
      const ackocopaySavingTo = {
        status: 1,
      };
      this.setState({ ackocopay: ackocopaySavingTo });
    }, 3000);

    const fulfilmentDetails = {
      payeeName: payeeName,
      accountNumber: this.valueOrUndefined(accountNumber),
      accountType: this.valueOrUndefined(accountType),
      ifsc: this.valueOrUndefined(ifscCode),
      bankName: this.valueOrUndefined(bankName.toString()),
      branchName: this.valueOrUndefined(branchName.toString()),
      upiPhone: this.valueOrUndefined(paytmNumber.toString()),
      upiAddress: preferredPaymentMode.toLocaleLowerCase() == "bank account" ? this.valueOrUndefined('') : this.valueOrUndefined(upiAddress),
      paymentCycle: this.valueOrUndefined(paymentCycle),
      invoiceMandatory,
    };
    let promise;
    if (beneficiaryId) {
      promise = getCentersWithBeneficiary(this.centerId).then((result) => {
        console.log(result);
        return new Promise((resolve, reject) => {
          if (result.result.length === 0) {
            this.setState({ saving: true });
            resolve();
            return;
          }
          const modal = Modal.confirm({
            content: (
              <ConfirmUpdateCentersFulfilments centers={result.result} />
            ),
            onCancel: () => {resolve();
            this.setState({ saving: true })},
            onOk: () => {resolve(true);
            this.setState({ saving: true })},
            cancelText: 'Update only this center',
            okText: 'Update all centers',
          });
        });
      });
    } else {
      this.setState({ saving: true });
      promise = Promise.resolve();
    }
    // this.setState({ loading: true });
    promise.then((updateAll) => {
      if (updateAll==true)
      {
        updateAll=true;
      }else{
        updateAll=false;
      }

      if(this.state.updateSameDetail)
      {
        this.setState({ requestSendStatus: false, requestSendStatusMessage: "" });
      }else{
        this.setState({ requestSendStatus: true, requestSendStatusMessage: "Wait..." });
      }

      submitNetworkCenterFulfilment(
        this.centerId,
        fulfilmentDetails,
        preferredPaymentMode,
        visitSpoc,
        masterHospitalId,
        tdsPercentage,
        billingEntityId,
        maternityDiscount,
        this.valueOrUndefined(remarks),
        updateAll,
        this.state.updateSameDetail,
        (res) => {
          if (!this.state.updateSameDetail)
          {
            if (res.message.toLocaleLowerCase() == "success") {
              this.setState({ requestSendStatus: true, requestSendStatusMessage: "Request raised successfully" })
            } else {
              this.setState({ requestSendStatus: true, requestSendStatusMessage: "Something went wrong" })
            }

            switch (res.data.payoutAccount.toLowerCase()) {
              case 'amhi':
              case 'acko':
              case 'ackocopay': {
                if (res.message === 'success') {
                  this.setState({
                    [res.data.payoutAccount.toLowerCase()]: {
                      status: 1,
                    },
                  });
                } else {
                  this.setState({
                    [res.data.payoutAccount.toLowerCase()]: {
                      status: -1,
                      errorMessage:
                        res.data.errorMessage || 'Something went wrong',
                    },
                  });
                }
                break;
              }
              default:
                break;
            }
          }
        },
        (status) => {
          this.fetchProfile();
          console.log(status);
          this.setState({ saved: true, selectingBillingEntity: false });
          const { amhi, acko, ackocopay } = this.state;

          if (
            amhi.status === 1 &&
            (acko.status === 1) && (ackocopay.status === 1)
          ) {
            // All have saved successfully. Set timeout to close modal
            setTimeout(() => {
              this.closeSavingModal();
            }, 3000);
          }
        },
        (err) => {
          this.fetchProfile();
          console.log(err);
        }
      );
    });
    // .then(result => {
    //   if (result.errorMessage) {
    //     message.warn(
    //       `Fulfilment saved with warning.
    //     ${result.errorMessage}`,
    //       6
    //     );
    //   }
    //   message.success('Success', 3);
    //   this.fetchProfile();
    // })
    // .catch(err => {
    //   console.log(err);
    // })
    // .finally(() => {
    //   this.setState({ loading: false });
    // });
  };
  getCenterFulfilments = (centerId) => {
    this.setState({ fulfilmentLoading: true });
    console.log(`billingEntityId logged ${centerId}`);
    fetchCenterFulfilments(centerId)
      .then((resp) => {
        //console.log(`response logged ${resp}`);
        console.log('response logged', JSON.stringify(resp, null, 2));

        const fulfilmentArray = resp.data.fulfilmentDetails.fulfilment;
        // const sp = resp.fulfilmentDetails.fulfilment[0].cortisBillingId;
        console.log('sample data', JSON.stringify(fulfilmentArray, null, 2));
        this.setState({ fetchedCenterFulfilments: fulfilmentArray });

      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({ fulfilmentLoading: false });
      });

  };

  submitEntity = (billingEntityId, centerId) => {
    console.log(`billingEntityId logged ${billingEntityId}`);
    modifyAndFetchCenterFulfilments(billingEntityId, centerId)
      .then((respn) => {
        //console.log(`response logged ${resp}`);
        console.log('response logged', JSON.stringify(respn, null, 2));
        this.setState({ selectingBillingEntity: false });
        fetchCenterFulfilments(centerId)
          .then((resp) => {
            const fulfilmentArray = resp.data.fulfilmentDetails.fulfilment;
            // const sp = resp.fulfilmentDetails.fulfilment[0].cortisBillingId;
            console.log('sample data', JSON.stringify(fulfilmentArray, null, 2));
            this.setState({ centerFulfilments: fulfilmentArray });
          });

      })
      .then(() => {
        this.fetchProfile();
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({ fulfilmentLoading: true });
      });
  };


  editFulfilment = (ele) => {
    // this.setState({
    //   formEditing: true,
    //   spocId: ele.spocId,
    //   name: ele.name || '',
    //   email: ele.email || '',
    //   phone: ele.phone || '',
    //   type: ele.type || '',
    //   sendWhatsApp: ele.sendWhatsApp === 1 ? true : false,
    //   sendEmail: ele.sendEmail === 1 ? true : false,
    //   sendCC: ele.sendCC === 1 ? true : false,
    //   sendSMS: ele.sendSMS === 1 ? true : false,
    //   sendCall: ele.sendCall === 1 ? true : false,
    //   commType: ele.commType || '',
    // });
  };

  removeFulfilment = (ele) => {
    Modal.confirm({
      title: 'Confirm Removal',
      content: `Are you sure you want to remove fulfilment details for the center ${ele.centerName}?`,
      onOk: () => {
        this.setState({ formSaving: true });
        removeNetworkCenterFulfilmentDetails(ele.centerId)
          .then(() => {
            this.getCenterFulfilments(ele.centerId);
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.setState({ formSaving: false });
          });
      },
    });
  };

  closeSavingModal = () => {
    this.setState({
      saving: false,
      saved: false,
      amhi: {
        status: 0,
      },
      acko: {
        status: 0,
      },
      ackocopay: {
        status: 0,
      },
    });
    this.setState({ updateSameDetail: false });
  };

  bankDetails = (e) => {
    //Link.state(this, 'longitude')
    // console.log('shashank', e);
    // if (e.key === 'Enter') {
    // console.log('enter press here! ');
    // console.log(e.target);
    const ifscCode = this.state.ifscCode;

    fetchBankDetailsFromIfscCode(ifscCode)
      .then((res) => {
        console.log(res.data);
        const bankDetails = res.data;
        this.setState({
          bankName: bankDetails.BANK,
          branchName: bankDetails.BRANCH,
        });
      })
      .catch((err) => {
        console.log(err);
      });
    // }
  };

  changePreferredPaymentMode = (e) => {
    this.setState({
      preferredPaymentMode: e,
    });
    if (e === 'Bank Account') {
      this.setState({
        upiAddress: '',
        paytmNumber: '',
      });
    } else if (e === 'Paytm') {
      this.setState({
        upiAddress: '',
        accountNumber: '',
        accountType: '',
        ifscCode: '',
        bankName: '',
        branchName: '',
      });
    } else if (e === 'UPI') {
      this.setState({
        paytmNumber: '',
        accountNumber: '',
        accountType: '',
        ifscCode: '',
        bankName: '',
        branchName: '',
      });
    }
  };



  onSearchCenter = (value) => {
    this.setState({ fetchingCenters: true });
    if (value.trim() === '') {
      this.setState({
        fetchedCenters: [],
        fetchingCenters: false,
      });
      return;
    }
    fetchCenters(value)
      .then((res) => {
        if (res && res.result && res.result.length != 0) {
          this.setState({
            fetchedCenters: res.result.map((ele) => ({
              key: ele.centerId,
              label: ele.title,
              locality: ele.locality,
            })),
            showError: false,
          });
        } else {
          const err = res;
          this.setState({
            showError: true,
          });
          throw err;
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.setState({
          fetchingCenters: false,
        });
      });
  };

  handleMasterHospital = (value) => {
    this.setState({
      masterHospitalId: value,
    });
  };

  checkIfVerificationprofileExists = async () => {
    try {
      const centerDetails = await fetchCenterBasicProfile(this.props.centerId);
      console.log(centerDetails);
      if (centerDetails.fulfilment.upiAddress) {
        this.setState({ upiVerified: true, upicheck: false, fetchedupi: centerDetails.fulfilment.upiAddress });
      }
      if (centerDetails.fulfilment.accountNumber && centerDetails.fulfilment.ifscCode) {
        this.setState({ bankVerified: true, bankcheck: false, fetchedaccountNumber: centerDetails.fulfilment.accountNumber, fetchedIfsc: centerDetails.fulfilment.ifscCode });
      }
    }
    catch (err) {
      console.log(err);
    }
  }

  handleUpiVerification = async () => {
    try {
      const { upiAddress, lastupiAddress, fetchedupi, validUpiresponse } = this.state;
      this.setState({ verifyLoading: true, lastupiAddress: upiAddress });
      if (lastupiAddress === upiAddress && validUpiresponse) {
        this.setState({ verifyLoading: false, upicheck: false });
        return message.error('Please update the upi details');
      }
      if (fetchedupi === upiAddress) {
        this.setState({ upicheck: false, upiVerified: true, verifyLoading: false });
        return message.success('UPI verified successfully');
      }
      const upiDetails = await verifyUpi(upiAddress);
      console.log(upiDetails.errsubCode);
      if (upiDetails.errsubCode !== '200') {
        this.setState({ validUpiresponse: false });
      }
      if (upiDetails.data && upiDetails.data.accountExists === 'YES') {
        message.success('UPI verified successfully');
        this.setState({ upiVerified: true, validUpiresponse: true });
        this.setState({ upicheck: false, payeeName: upiDetails.data.nameAtBank });
      }
      if (upiDetails.errsubCode === '200') {
        this.setState({ validUpiresponse: true });
      }
      this.setState({ verifyLoading: false });
    }
    catch (err) {
      console.log(err);
      this.setState({ verifyLoading: false });
    }
  }

  handleBankVerification = async () => {
    try {
      const { accountNumber, ifscCode, lastaccnumber, lastifsc, fetchedaccountNumber, fetchedIfsc, validBankresponse } = this.state;
      this.setState({ verifyLoading: true, lastaccnumber: accountNumber, lastifsc: ifscCode });
      if (lastaccnumber === accountNumber && lastifsc === ifscCode && validBankresponse) {
        this.setState({ verifyLoading: false, bankcheck: false });
        return message.error('Please update the bank details');
      }
      if (fetchedaccountNumber === accountNumber && fetchedIfsc === ifscCode) {
        this.setState({ bankcheck: false, bankVerified: true, verifyLoading: false });
        return message.success('Bank details verified successfully');
      }
      const bankDetails = await verifyBankAccount(accountNumber, ifscCode);
      console.log(bankDetails);
      if (bankDetails.errsubCode !== '200') {
        this.setState({ validBankresponse: false });
      }
      if (bankDetails.message === 'success') {
        message.success('Bank details verified successfully');
        this.setState({ bankVerified: true, validBankresponse: true });
        this.setState({ bankcheck: false, payeeName: bankDetails.data.nameAtBank });
      }
      if (bankDetails.errsubCode === '200') {
        this.setState({ validBankresponse: true });
      }
      this.setState({ verifyLoading: false });
    }
    catch (err) {
      console.log(err);
      this.setState({ verifyLoading: false });
    }
  }
  changeToDocument = () => {
    return
  }
  handlePopUp=()=>
  {
    this.setState({requestSendStatusMessage:false});
  }

  checkIfFulfilmentDetailsChangedInForm = () => {
    const { preViusFulfilmentDetail } = this.state;
    if (preViusFulfilmentDetail.preViusFulfilmentDetailUpdated) {
      const currentDetails = {
        payeeName: this.state.payeeName,
        accountNumber: this.state.accountNumber,
        ifscCode: this.state.ifscCode,
        bankName: this.state.bankName,
        accountType: this.state.accountType,
        branchName: this.state.branchName,
        upiAddress: this.state.upiAddress,
        visitSpoc: this.state.visitSpoc,
        preferredPaymentMode: this.state.preferredPaymentMode,
        remarks: this.state.remarks,
        invoiceMandatory: this.state.invoiceMandatory ? 1: 0,
        tdsPercentage: parseFloat(this.state.tdsPercentage).toFixed(2),
        paymentCycle: this.state.paymentCycle,
        masterHospitalId: this.state.masterHospitalId
      };
      const keysToCheck = [
        'payeeName',
        'accountNumber',
        'ifscCode',
        'bankName',
        'accountType',
        'branchName',
        'upiAddress',
        'visitSpoc',
        'preferredPaymentMode',
        'remarks',
        'invoiceMandatory',
        'tdsPercentage',
        'paymentCycle',
        'masterHospitalId'
      ];

      let ab = false

      for (const key of keysToCheck) {
        if (preViusFulfilmentDetail[key]!=null && preViusFulfilmentDetail[key] !== currentDetails[key]) {
          return true
        }
      }
      return false;
    }
  }

  render() {
    const {
      loading,
      fulfilmentLoading,
      showAddFulfilmentForm,
      updateSameDetail,
      showEditForm,
      preferredPaymentMode,
      paymentCycle,
      saved,
      saving,
      amhi,
      acko,
      ackocopay,
      visitSpoc,
      invoiceMandatory,
      fetchingCenters,
      fetchedCenters,
      showError,
      maternityCenter,
      masterHospitalId,
      masterHospitalName,
      billingEntities,
      billingEntityId,
      selectingBillingEntity,
      bankcheck,
      upicheck,
      bankVerified,
      upiVerified,
      verifyLoading,
      filterVistSpocs,
      zohoCompanyName,
      zohoVendorId,
      zohoVendorName,
      pan,
      nameAsPerPan
    } = this.state;

    //const res=this.checkIfFulfilmentDetailsChangedInForm();

    let showAutoCloseMessage = false;
    if (
      saved &&
      amhi.status === 1 &&
      acko.status === 1 &&
      ackocopay.status === 1
    ) {
      // All saved successfully
      showAutoCloseMessage = true;
    }
    const payeeNameInputLink = Link.state(this, 'payeeName');
    const accountNumberInputLink = Link.state(this, 'accountNumber');
    const accountTypeInputLink = Link.state(this, 'accountType');
    const ifscCodeInputLink = Link.state(this, 'ifscCode');
    const bankNameInputLink = Link.state(this, 'bankName');
    const branchNameInputLink = Link.state(this, 'branchName');
    const tdsPercentageInputLink = Link.state(this, 'tdsPercentage');
    const maternityDiscountInputLink = Link.state(this, 'maternityDiscount');
    const paytmNumberInputLink = Link.state(this, 'paytmNumber');
    const upiAddressInputLink = Link.state(this, 'upiAddress');
    const remarksInputLink = Link.state(this, 'remarks');

    console.log(`billing id ${billingEntityId}`);
    console.log(`selectingBillingEntity id ${selectingBillingEntity}`);

    console.log(this.props.isCenterEnabled, 'enabling status');

    const renderFulfilment = (fulfilmentData, idx) => {
      return (
        <Row key={idx}>
          <Col key={idx} span={24} xs={24} md={12}>
            <Card>
              <EduRowComponent>
                <Row type="flex" align="middle" justify="space-between">
                  <Col>
                    <Row type="flex" align="middle" gutter={[16, 16]}>
                      <Col>
                        <Title level={4} style={{ margin: 0 }}>
                          {fulfilmentData.payeeName}
                        </Title>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col xs={12}>
                    <Paragraph style={{ margin: 0 }}>
                      <span style={{ fontWeight: 'bold' }}>centerId: </span>
                      {fulfilmentData.centerId}
                    </Paragraph>
                  </Col>
                  <Col xs={12}>
                    <Paragraph style={{ margin: 0 }}>
                      <span style={{ fontWeight: 'bold' }}>centerName: </span>
                      {fulfilmentData.centerName}
                    </Paragraph>
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col xs={12}>
                    <Paragraph style={{ margin: 0 }}>
                      <span style={{ fontWeight: 'bold' }}>Account Number: </span>
                      {fulfilmentData.accountNumber}
                    </Paragraph>
                  </Col>
                  <Col xs={12}>
                    <Paragraph style={{ margin: 0 }}>
                      <span style={{ fontWeight: 'bold' }}>Account Type: </span>
                      {fulfilmentData.accountType}</Paragraph>
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col xs={12}>
                    <Paragraph style={{ margin: 0 }}>
                      <span style={{ fontWeight: 'bold' }}>IFSC Code: </span>
                      {fulfilmentData.ifscCode}
                    </Paragraph>
                  </Col>
                  <Col xs={12}>
                    <Paragraph style={{ margin: 0 }}>
                      <span style={{ fontWeight: 'bold' }}>UPI Phone: </span>
                      {fulfilmentData.upiPhone}</Paragraph>
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col xs={12}>
                    <Paragraph style={{ margin: 0 }}>
                      <span style={{ fontWeight: 'bold' }}>Preferred Payment: </span>
                      {fulfilmentData.preferredPayment}
                    </Paragraph>
                  </Col>
                  <Col xs={12}>
                    <Paragraph style={{ margin: 0 }}>
                      <span style={{ fontWeight: 'bold' }}>Payment Cycle: </span>
                      {fulfilmentData.paymentCycle}
                    </Paragraph>
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col xs={12}>
                    <Paragraph style={{ margin: 0 }}>
                      <span style={{ fontWeight: 'bold' }}>Bank Name: </span>
                      {fulfilmentData.bankName}</Paragraph>
                  </Col>
                  <Col xs={12}>
                    <Paragraph style={{ margin: 0 }}>
                      <span style={{ fontWeight: 'bold' }}>Branch: </span>
                      {fulfilmentData.branch}
                    </Paragraph>
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col xs={12}>
                    <Paragraph style={{ margin: 0 }}>
                      <span style={{ fontWeight: 'bold' }}> Visit Spoc: </span>
                      {fulfilmentData.visitSpoc}</Paragraph>
                  </Col>
                  <Col xs={12}>
                    <Paragraph style={{ margin: 0 }}>
                      <span style={{ fontWeight: 'bold' }}> Invoice Mandatory: </span>
                      {fulfilmentData.invoiceMandatory}
                    </Paragraph>
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col xs={12}>
                    <Paragraph style={{ margin: 0 }}>
                      <span style={{ fontWeight: 'bold' }}>Cortis Billing ID: </span>
                      {fulfilmentData.cortisBillingId}
                    </Paragraph>
                  </Col>
                  <Col xs={12}>
                    <Paragraph style={{ margin: 0 }}>
                      <span style={{ fontWeight: 'bold' }}> Remarks: : </span>
                      {fulfilmentData.remarks}
                    </Paragraph>
                  </Col>
                </Row>
                <Row gutter={[16, 16]}>
                  <Col xs={24}>
                    <Paragraph style={{ margin: 0 }}>
                      <span style={{ fontWeight: 'bold' }}>Payout Beneficiary ID: </span>
                      {fulfilmentData.payoutBeneficiaryId}
                    </Paragraph>
                  </Col>
                </Row>
              </EduRowComponent>

              <Row gutter={[24, 16]} style={{ marginTop: '10px' }}>
                <Col xs={24} md={12}>
                  <Button block type="primary" onClick={() => { this.setState({ showAddFulfilmentForm: true }) }}>
                    Edit
                  </Button>
                </Col>
                {/* <Col xs={24} md={12}>
                  <Button
                    block
                    type="danger"
                    onClick={() => this.removeFulfilment(fulfilmentData)}
                  >
                    Remove Fulfilment
                  </Button>
                </Col> */}
              </Row>
            </Card>
          </Col>
        </Row>
      );
    };

    const handleSearch = (inputValue) => {
      const filteredList = this.props.visitSpocs.filter((spoc) =>
        spoc.name.toLowerCase().includes(inputValue.toLowerCase())
      );
      this.setState({ filterVistSpocs: filteredList || [] });
    };

    const handleChange = (value) => {
      this.setState({ visitSpoc: value });
    };

    const renderFulfilmentForm = () => {

      console.log('inside render fulfilment form');

      return (
        <Row type="flex" gutter={[16, 16]}>
          <Col span={24}>
            <TitleText>Network Center Fulfilment</TitleText>
          </Col>
          {loading ? (
            <Spin spinning={loading} />
          ) : (
            <Col xs={{ order: 2, span: 24 }} md={{ order: 1, span: 12 }}>
              <Row gutter={[16, 16]}>
                {/* {this.state.validationErrors.dependentName ? (
              <ValidationText>
                {this.state.validationErrors.dependentName.errorMessage}
              </ValidationText>
            ) : null} */}
                <Col span={12}>
                  <LabelText>Preferred Payment Mode</LabelText>
                  <Select
                    style={{ width: '100%' }}
                    value={preferredPaymentMode}
                    defaultValue="Bank Account"
                    onChange={this.changePreferredPaymentMode}
                  >
                    <Option value="Bank Account">Bank Account</Option>
                    <Option value="UPI">UPI</Option>
                    {/* <Option value="Paytm">Paytm</Option> */}
                  </Select>
                </Col>

                <Col span={12}>
                  <LabelText>Payee Name</LabelText>
                  <StyledInputBox
                    className="visit-input"
                    valueLink={payeeNameInputLink}
                    placeholder="Payee Name"
                  />
                </Col>

                {preferredPaymentMode === 'Bank Account' ? (
                  <Col span={12}>
                    <LabelText>Account Number</LabelText>
                    <StyledInputBox
                      className="visit-input"
                      valueLink={accountNumberInputLink}
                      placeholder="Account Number"
                    />
                  </Col>
                ) : null}x
                {preferredPaymentMode === 'Bank Account' ? (
                  <Col span={12}>
                    <LabelText>Account Type</LabelText>
                    <StyledInputBox
                      className="visit-input"
                      valueLink={accountTypeInputLink}
                      placeholder="Account Type"
                    />
                  </Col>
                ) : null}

                {preferredPaymentMode === 'Bank Account' ? (
                  <Col span={12}>
                    <LabelText>IFSC Code</LabelText>
                    <StyledInputBox
                      className="visit-input"
                      valueLink={ifscCodeInputLink}
                      onBlur={this.bankDetails}
                      placeholder="IFSC Code"
                    />
                    {
                      !bankVerified ? (bankcheck && !verifyLoading ? (<VerifyBtnY onClick={this.handleBankVerification}>Verify</VerifyBtnY>) : (<VerifyBtnN>Verify</VerifyBtnN>)) : (<VerifyBtnN>Verify</VerifyBtnN>)
                    }
                    {
                      verifyLoading && (<ThreeDots
                        height="40"
                        width="40"
                        radius="9"
                        color="#4096ff"
                        ariaLabel="three-dots-loading"
                        wrapperStyle={{}}
                        wrapperClassName=""
                        visible={true}
                      />)
                    }
                  </Col>
                ) : null}
                {preferredPaymentMode === 'Bank Account' ? (
                  <Col span={12}>
                    <LabelText>Bank Name</LabelText>
                    <StyledInputBox
                      className="visit-input"
                      valueLink={bankNameInputLink}
                      placeholder="Bank Name"
                    />
                  </Col>
                ) : null}
                {preferredPaymentMode === 'Bank Account' ? (
                  <Col span={12}>
                    <LabelText>Branch</LabelText>
                    <StyledInputBox
                      className="visit-input"
                      valueLink={branchNameInputLink}
                      placeholder="Branch"
                    />
                  </Col>
                ) : null}

                {preferredPaymentMode === 'Paytm' ? (
                  <Col span={12}>
                    <LabelText>PayTM Number</LabelText>
                    <StyledInputBox
                      className="visit-input"
                      valueLink={paytmNumberInputLink}
                      placeholder="PayTM Number"
                    />
                  </Col>
                ) : null}

                {preferredPaymentMode === 'UPI' ? (
                  <Col span={12}>
                    <LabelText>UPI Address</LabelText>
                    <StyledInputBox
                      className="visit-input"
                      valueLink={upiAddressInputLink}
                      placeholder="UPI ID"
                    />
                    {/* {
                      !upiVerified ? (upicheck && !verifyLoading ? (<VerifyBtnY onClick={this.handleUpiVerification}>Verify</VerifyBtnY>) : (<VerifyBtnN>Verify</VerifyBtnN>)) : (<VerifyBtnN>Verify</VerifyBtnN>)
                    }
                    {
                      verifyLoading && (<ThreeDots
                        height="40"
                        width="40"
                        radius="9"
                        color="#4096ff"
                        ariaLabel="three-dots-loading"
                        wrapperStyle={{}}
                        wrapperClassName=""
                        visible={true}
                      />)
                    } */}
                  </Col>
                ) : null}

                <Col span={12}>
                  <LabelText>Payment Cycle</LabelText>
                  <Select
                    style={{ width: '100%' }}
                    value={paymentCycle}
                    defaultValue="before consultation"
                    onChange={(e) => this.setState({ paymentCycle: e })}
                  >
                    <Option value="before consultation">
                      Before consultation
                    </Option>
                    <Option value="after consultation">After consultation</Option>
                    <Option value="within 2">Within 2 days</Option>
                    <Option value="within 7">Within 7 days</Option>
                    <Option value="within 15">Within 15 days</Option>
                    <Option value="30 Days">30 days</Option>
                  </Select>
                </Col>
                {maternityCenter && (
                  <Col span={12}>
                    <LabelText>Maternity Discount</LabelText>
                    <StyledInputBox
                      className="visit-input"
                      valueLink={maternityDiscountInputLink}
                      placeholder="Maternity Discount"
                    />
                  </Col>
                )}
                <Col span={12}>
                  <LabelText>Visit Spoc</LabelText>
                  <Select
                    style={{ width: "100%" }}
                    showSearch
                    value={visitSpoc}
                    placeholder="Select or Search Visit Spoc"
                    optionFilterProp="children"
                    onSearch={handleSearch}
                    onChange={handleChange}
                    filterOption={false} // Disables default filtering to use custom filtering
                  >
                    {filterVistSpocs.length > 0 && (
                      filterVistSpocs.map((spoc) => (
                        <Option key={spoc.operatorId} value={spoc.operatorId}>
                          {spoc.name}
                        </Option>
                      ))
                    )}
                  </Select>
                </Col>
                <Col span={12}>
                  <LabelText>Master Hospital</LabelText>
                  <Select
                    showSearch
                    style={{ width: '100%' }}
                    dropdownMatchSelectWidth={false}
                    notFoundContent={
                      fetchingCenters ? <Spin size="small" /> : null
                    }
                    defaultValue={masterHospitalName}
                    defaultActiveFirstOption={false}
                    showArrow={false}
                    filterOption={false}
                    placeholder="Centers"
                    onSearch={this.debouncedFetchHealthCenters}
                    onChange={(e) => {
                      this.handleMasterHospital(e);
                    }}
                  >
                    {fetchedCenters.map((d) => (
                      <Option key={d.key}>
                        <Col style={{ padding: '0px' }}>
                          {d.label}({d.locality}){' '}
                          <Typography.Text code>
                            Is Active - {d.isActive ? 'Yes' : 'No'}
                          </Typography.Text>
                        </Col>
                      </Option>
                    ))}
                  </Select>
                  {showError && (
                    <ParagraphText>
                      No Hospitals Found! for the search value
                    </ParagraphText>
                  )}
                </Col>
                <Col span={12}>
                  <LabelText>TDS Percentage</LabelText>
                  <StyledInputBox
                    className="visit-input"
                    valueLink={tdsPercentageInputLink}
                    placeholder="TDS Percentage"
                  />
                </Col>
                <Col span={12}>
                  <LabelText>Remarks</LabelText>
                  <StyledInputBox
                    className="visit-input"
                    valueLink={remarksInputLink}
                    placeholder="Remarks"
                  />
                </Col>
                <Col span={12}>
                  <LabelText>Invoice Mandatory</LabelText>
                  <Switch
                    checked={invoiceMandatory}
                    onChange={() =>
                      this.setState({ invoiceMandatory: !invoiceMandatory })
                    }
                  />
                </Col>
                <Col span={24}>
                  <Button
                    block
                    type="primary"
                    size="large"
                    onClick={() => {
                      this.setState({ updateSameDetail: false, saving: false }, () => {
                        this.submit();
                      });
                    }}
                  //onClick={this.submit}
                  >
                    <ButtonText>Send for approval</ButtonText>
                  </Button>
                  <Button
                    block
                    type="primary"
                    size="large"
                    onClick={() => {
                        this.setState({ updateSameDetail: true,saving:false}, () => {
                        this.submit();
                      });
                    }}
                    style={{ marginTop: '5px', background: '#ffffff' }}
                  >
                    <ButtonText style={{ color: '#007bff' }}>Save Same Detail</ButtonText>
                  </Button>



                  <Button block type="primary" size="large" onClick={() => { this.setState({ showAddFulfilmentForm: false }) }} style={{ marginTop: '5px', background: '#ffffff' }}>
                    <ButtonText style={{ color: '#007bff' }}>Cancel</ButtonText>
                  </Button>
                </Col>
              </Row>
            </Col>
          )}
          <Modal
            visible={this.state.saving && this.state.updateSameDetail}
            title="Saving Fulfilment Details"
            footer={false}
            closable={false}
          >
            <Row gutter={[16, 16]}>
              <Col span={24}>
                {amhi.status === 0 ? (
                  <Spin size="small" />
                ) : amhi.status === 1 ? (
                  <Icon
                    style={{ fontSize: '20px' }}
                    type="check-circle"
                    theme="twoTone"
                    twoToneColor="#52c41a"
                  />
                ) : (
                  <Icon
                    style={{ fontSize: '20px' }}
                    type="warning"
                    theme="twoTone"
                    twoToneColor="#fa8c16"
                  />
                )}
                <Typography.Text style={{ marginLeft: '8px' }}>
                  {amhi.status === 0
                    ? 'Saving fulfilment details for AMHI'
                    : amhi.status === 1
                      ? 'Fulfilment details for AMHI saved successfully'
                      : `Error saving fulfilment details for AHMI - ${amhi.errorMessage}`}
                </Typography.Text>
              </Col>
              <Col span={24}>
                {acko.status === 0 ? (
                  !saved ? (
                    <Spin size="small" />
                  ) : (
                    <Icon
                      style={{ fontSize: '20px' }}
                      type="warning"
                      theme="twoTone"
                      twoToneColor="#fa8c16"
                    />
                  )
                ) : acko.status === 1 ? (
                  <Icon
                    style={{ fontSize: '20px' }}
                    type="check-circle"
                    theme="twoTone"
                    twoToneColor="#52c41a"
                  />
                ) : (
                  <Icon
                    style={{ fontSize: '20px' }}
                    type="warning"
                    theme="twoTone"
                    twoToneColor="#fa8c16"
                  />
                )}
                <Typography.Text style={{ marginLeft: '8px' }}>
                  {acko.status === 0
                    ? saved
                      ? 'Acko - Saving Cancelled'
                      : 'Saving fulfilment details for Acko'
                    : acko.status === 1
                      ? 'Fulfilment details for Acko saved successfully'
                      : `Error saving fulfilment details for Acko - ${acko.errorMessage}`}
                </Typography.Text>
              </Col>
              <Col span={24}>
                {ackocopay.status === 0 ? (
                  !saved ? (
                    <Spin size="small" />
                  ) : (
                    <Icon
                      style={{ fontSize: '20px' }}
                      type="warning"
                      theme="twoTone"
                      twoToneColor="#fa8c16"
                    />
                  )
                ) : ackocopay.status === 1 ? (
                  <Icon
                    style={{ fontSize: '20px' }}
                    type="check-circle"
                    theme="twoTone"
                    twoToneColor="#52c41a"
                  />
                ) : (
                  <Icon
                    style={{ fontSize: '20px' }}
                    type="warning"
                    theme="twoTone"
                    twoToneColor="#fa8c16"
                  />
                )}
                <Typography.Text style={{ marginLeft: '8px' }}>
                  {ackocopay.status === 0
                    ? saved
                      ? 'Acko Copay - Saving Cancelled'
                      : 'Saving fulfilment details for Acko'
                    : ackocopay.status === 1
                      ? 'Fulfilment details for Acko copay saved successfully'
                      : `Error saving fulfilment details for Acko copay - ${ackocopay.errorMessage}`}
                </Typography.Text>
              </Col>
              {/* {saved && (
                <>
                  <Col span={24}>
                    <Button type="primary" onClick={this.closeSavingModal()}>
                      Close
                    </Button>
                  </Col>
                  {showAutoCloseMessage && (
                    <Col span={24}>
                      <Typography.Text>
                        This window will automatically close in 3 seconds
                      </Typography.Text>
                    </Col>
                  )}
                </>
              )} */}
            </Row>
          </Modal>

          <Modal
            visible={this.state.requestSendStatus}
            closable={false}
            okText="Ok"
            onOk={this.handleRequestRaisedStatus}
            footer={[
              <Button
                key="ok"
                type={
                  ["request raised successfully", "wait..."].includes(this.state.requestSendStatusMessage.toLowerCase())
                    ? "primary"
                    : "danger"
                }
                onClick={this.handleRequestRaisedStatus}
              >
                OK
              </Button>

            ]}
          >
            <Row>
              <div style={{ marginBottom: '5px', display: 'flex' }}>
                <label
                  style={{
                    minWidth: '200px',
                    fontSize: '18px',
                  }}
                >
                  {this.state.requestSendStatusMessage}
                </label>
              </div>
            </Row>
          </Modal>
        </Row>
      );
    };


    return (
      <Row type="flex" gutter={[16, 16]}>
        <Row type="flex" gutter={[16, 16]}>
          <Col span={24}>
            <TitleText>Network Center Fulfilment</TitleText>
          </Col>
          <Col span={18}>
            {/* <LabelText style={{ width: '500px' }}>
              Cortis Billing Entity/Accounts Vendor Name (Once mapped it
              cannot be changed)
            </LabelText>

            <Select
              style={{ width: '100%' }}
              disabled={(billingEntityId && !selectingBillingEntity) || loading}
              value={billingEntityId || 'Select'}
              onChange={this.handleBillingEntityChange}
              showSearch
              filterOption={(inputValue, option) => {
                // console.log(inputValue, option, billingEntities);
                // Find option.key from billingEntities
                const thisOption = billingEntities.filter((item) => {
                  return item.cortisBillingEntityId == option.key;
                });
                console.log('ThisOption', thisOption, option);
                let found = false;
                thisOption.forEach((item) => {
                  if (
                    item.zohoCompanyName &&
                    item.zohoCompanyName.toLowerCase().includes(inputValue)
                  ) {
                    found = true;
                  }
                  if (
                    item.zohoVendorName &&
                    item.zohoVendorName.toLowerCase().includes(inputValue)
                  ) {
                    found = true;
                  }
                  if (
                    item.zohoVendorName &&
                    item.cortisBillingEntityId == inputValue
                  ) {
                    found = true;
                  }
                  if (
                    item.zohoVendorId &&
                    item.zohoVendorId.toLowerCase().includes(inputValue)
                  ) {
                    found = true;
                  }
                });
                return found;
              }}
            >
              {billingEntities &&
                billingEntities.length > 0 &&
                billingEntities.map((item) => (
                  <Option
                    key={item.cortisBillingEntityId}
                    value={item.cortisBillingEntityId}
                  >
                    Display Name - {item.zohoVendorName} - Company Name -{' '}
                    {item.zohoCompanyName}
                  </Option>
                ))}
            </Select> */}
            {!(billingEntityId && !selectingBillingEntity) ? <Form.Item
              label="Cortis Billing Entity/Accounts Vendor Name (Once mapped it
              cannot be changed)"
              name="billingEntity"
              style={{ width: '500px' }}
              rules={[{ required: true, message: 'Please select a billing entity!' }]}
            >
              <Select
                showSearch
                style={{ width: '100%' }}
                placeholder="Search by CBE Id, Name, Name on PAN, or PAN Number"
                value={billingEntityId || 'Select'}
                onSearch={this.handleSearchNew}
                onChange={this.handleBillingEntityChange}
                disabled={(billingEntityId && !selectingBillingEntity) || loading}
                filterOption={false}
                optionLabelProp="label"
                notFoundContent={
                  <div style={{ padding: '10px', textAlign: 'center', borderRadius: '10px', color: 'red' }}>
                    No billing entity found by this name
                  </div>
                }
              >
                {billingEntities && billingEntities.length && billingEntities.map((item) => (
                  <Select.Option
                    key={item.cortisBillingEntityId}
                    value={item.cortisBillingEntityId}
                    label={`CBE ID : ${item.cortisBillingEntityId} -- ${item.zohoCompanyName}`}
                    data={item}
                  >
                    <div>
                      <span style={{ color: "gray" }}>CBE Id: {item.cortisBillingEntityId}</span>
                      <br />
                      <span style={{ color: "gray" }}>Vendor Id: {item.zohoVendorId}</span>
                      <br />
                      <span style={{ color: "gray" }}>Vendor Name: {item.zohoVendorName}</span>
                      <br />
                      <span style={{ color: "gray" }}>Company Name: {item.zohoCompanyName}</span>
                      <br />
                      <span style={{ color: "gray" }}>PAN: {item.pan}</span>
                    </div>
                  </Select.Option>
                ))}
              </Select>
            </Form.Item> :
              <div>
                <h2>Billing Details</h2>
                <Form
                  layout="vertical"
                  style={{
                    background: "#f9f9f9",
                    padding: "20px",
                    borderRadius: "8px",
                    boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <Row gutter={16}>
                    <Col span={12}>
                      <Form.Item
                        label={<strong>Billing Company Name:</strong>}
                        name="zohoCompanyName"
                        style={{ marginBottom: "15px" }}
                      >
                        <input value={zohoCompanyName} readOnly size="large" style={{ width: "90%" }} />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label={<strong>PAN Number:</strong>}
                        name="pan"
                        rules={[{ required: true, message: "PAN Number is required" }]}
                        style={{ marginBottom: "15px" }}
                      >
                        <input value={pan} readOnly size="large" style={{ width: "90%" }} />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={16}>
                    <Col span={12}>
                      <Form.Item
                        label={<strong>Cortis Billing Entity Id:</strong>}
                        name="zohoVendorId"
                        style={{ marginBottom: "15px" }}
                      >
                        <input value={zohoVendorId} readOnly size="large" style={{ width: "90%" }} />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label={<strong>Billing Vendor Name:</strong>}
                        name="zohoVendorName"
                        style={{ marginBottom: "15px" }}
                      >
                        <input value={zohoVendorName} readOnly size="large" style={{ width: "90%" }} />
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label={<strong>Name On Pan:</strong>}
                        name="nameAsPerPan"
                        style={{ marginBottom: "15px" }}
                      >
                        <input value={nameAsPerPan} readOnly size="large" style={{ width: "90%" }} />
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </div>}
          </Col>
          {(billingEntityId && selectingBillingEntity) && <Col span={4} style={{ marginTop: '22px' }}>
            <Button block type="primary" size="large" onClick={() => this.submitEntity(billingEntityId, this.centerId)}>
              <ButtonText>Submit</ButtonText>
            </Button>
          </Col>}
        </Row>
        {/*  from here the rendering of the form*/}
        {/*previous code here ====================================================================== */}

        {!showAddFulfilmentForm && !showEditForm && <React.Fragment>{fulfilmentLoading ? <Col span={24}>{this.state.centerFulfilments.map(renderFulfilment)}</Col>
          :
          <Col span={24}>{this.state.fetchedCenterFulfilments.map(renderFulfilment)}</Col>
        }
        </React.Fragment>}
        <React.Fragment>{showAddFulfilmentForm || showEditForm ? <Col span={24}>{renderFulfilmentForm()}</Col>
          :
          <div></div>
        }
        </React.Fragment>
        <React.Fragment>
          <Col span={24}>
            <Button
              style={{ alignSelf: 'center', flex: 0, padding: 4 }}
              onClick={() => { this.setState({ showAddFulfilmentForm: true }) }}
            >
              Add Fulfilment
            </Button>
            {/* <Button
            style={{ alignSelf: 'center', flex: 0, padding: 4, marginLeft: 10 }}
            onClick={this.changeToDocument}
            >
             Add Documents
            </Button> */}
          </Col>
          <Col span={24} style={{ color: 'red', display: this.props.isCenterEnabled ? 'none' : 'block' }} >
            *Note: Complete the Documentation First to get the Fulfilment Details.
          </Col>
        </React.Fragment>

        {/*end of my code ================================================================================= */}
        <Modal
          visible={this.state.saving && this.state.updateSameDetail}
          title="Saving Fulfilment Details"
          footer={false}
          closable={true}
          onCancel={()=>this.closeSavingModal()} 
        >
          <Row gutter={[16, 16]}>
            <Col span={24}>
              {amhi.status === 0 ? (
                <Spin size="small" />
              ) : amhi.status === 1 ? (
                <Icon
                  style={{ fontSize: '20px' }}
                  type="check-circle"
                  theme="twoTone"
                  twoToneColor="#52c41a"
                />
              ) : (
                <Icon
                  style={{ fontSize: '20px' }}
                  type="warning"
                  theme="twoTone"
                  twoToneColor="#fa8c16"
                />
              )}
              <Typography.Text style={{ marginLeft: '8px' }}>
                {amhi.status === 0
                  ? 'Saving fulfilment details for AMHI'
                  : amhi.status === 1
                    ? 'Fulfilment details for AMHI saved successfully'
                    : `Error saving fulfilment details for AHMI - ${amhi.errorMessage}`}
              </Typography.Text>
            </Col>
            <Col span={24}>
              {acko.status === 0 ? (
                !saved ? (
                  <Spin size="small" />
                ) : (
                  <Icon
                    style={{ fontSize: '20px' }}
                    type="warning"
                    theme="twoTone"
                    twoToneColor="#fa8c16"
                  />
                )
              ) : acko.status === 1 ? (
                <Icon
                  style={{ fontSize: '20px' }}
                  type="check-circle"
                  theme="twoTone"
                  twoToneColor="#52c41a"
                />
              ) : (
                <Icon
                  style={{ fontSize: '20px' }}
                  type="warning"
                  theme="twoTone"
                  twoToneColor="#fa8c16"
                />
              )}
              <Typography.Text style={{ marginLeft: '8px' }}>
                {acko.status === 0
                  ? saved
                    ? 'Acko - Saving Cancelled'
                    : 'Saving fulfilment details for Acko'
                  : acko.status === 1
                    ? 'Fulfilment details for Acko saved successfully'
                    : `Error saving fulfilment details for Acko - ${acko.errorMessage}`}
              </Typography.Text>
            </Col>
            <Col span={24}>
              {ackocopay.status === 0 ? (
                !saved ? (
                  <Spin size="small" />
                ) : (
                  <Icon
                    style={{ fontSize: '20px' }}
                    type="warning"
                    theme="twoTone"
                    twoToneColor="#fa8c16"
                  />
                )
              ) : ackocopay.status === 1 ? (
                <Icon
                  style={{ fontSize: '20px' }}
                  type="check-circle"
                  theme="twoTone"
                  twoToneColor="#52c41a"
                />
              ) : (
                <Icon
                  style={{ fontSize: '20px' }}
                  type="warning"
                  theme="twoTone"
                  twoToneColor="#fa8c16"
                />
              )}
              <Typography.Text style={{ marginLeft: '8px' }}>
                {ackocopay.status === 0
                  ? saved
                    ? 'Acko Copay - Saving Cancelled'
                    : 'Saving fulfilment details for Acko'
                  : ackocopay.status === 1
                    ? 'Fulfilment details for Acko copay saved successfully'
                    : `Error saving fulfilment details for Acko copay - ${ackocopay.errorMessage}`}
              </Typography.Text>
            </Col>
            {/* {saved && (
              <>
                <Col span={24}>
                  <Button type="primary" onClick={this.closeSavingModal()}>
                    Close
                  </Button>
                </Col>
                {showAutoCloseMessage && (
                  <Col span={24}>
                    <Typography.Text>
                      This window will automatically close in 3 seconds
                    </Typography.Text>
                  </Col>
                )}
              </>
            )} */}
          </Row>
        </Modal>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
  visitSpocs: state.info.operators,
});

export default connect(mapStateToProps)(NetworkCenterFulfilment);

